var baseMerge=require("./_baseMerge"),createAssigner=require("./_createAssigner"),merge=createAssigner(function(e,r,s){baseMerge(e,r,s)});module.exports=merge;